import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { AzureMySqlTableDataset } from 'app/model/dataset/azure-mysql-table.dataset';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureMySql.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureMySqlTableDataset) }
})
export class AzureMySqlCopySource extends TabularCopySource {
    public static readonly QUERY_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number = 120;
}
